import React from 'react';
import { Flex } from 'common/common-components.styled';
import { AskQuestion } from './ask-question/ask-question';
import { ModalMenu } from './modal-menu';
import { TableComponentsProps } from './table-components.props';

export const MyVehicleTableRightComponent = ({ row }: TableComponentsProps) => {
  return (
    <Flex gap='20px'>
      <AskQuestion row={row} />
      <ModalMenu row={row} />
    </Flex>
  );
};
